import React, {useState} from 'react';
import {Link, useLocation} from 'react-router-dom';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiMenu, FiX, FiPlus} = FiIcons;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    {name: 'Home', href: '/'},
    {name: 'BOP', href: '/business-owners-policy'},
    {name: 'Workers Comp', href: '/workers-compensation'},
    {name: 'General Liability', href: '/general-liability'},
    {name: 'Commercial Auto', href: '/commercial-auto'},
    {name: 'Commercial Property', href: '/commercial-property'},
    {name: 'Cyber Liability', href: '/cyber-liability'},
    {name: 'Tools & Equipment', href: '/tools-equipment'},
    {name: 'EPLI', href: '/epli'},
    {name: 'About', href: '/about'},
    {name: 'Contact', href: '/contact'}
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      {/* Top Logo Bar */}
      <div className="bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-center items-center h-20">
            {/* Partnership Logos */}
            <div className="flex items-center space-x-4">
              <Link to="/" className="flex-shrink-0">
                <img
                  src="https://app1.sharemyimage.com/2025/05/19/burbank-insurance-services-in-california-logo.png"
                  alt="Burbank Insurance Services Logo"
                  className="h-12 w-auto"
                />
              </Link>
              <div className="flex items-center space-x-3">
                <div className="bg-primary-100 rounded-full p-2">
                  <SafeIcon icon={FiPlus} className="h-4 w-4 text-primary-600" />
                </div>
                <img
                  src="https://cdn1.sharemyimage.com/smi/2025/09/08/Next_Insurance_Logo.svg.png"
                  alt="Next Insurance Logo"
                  className="h-8 w-auto"
                />
              </div>
            </div>

            {/* Mobile menu button */}
            <div className="md:hidden absolute right-4">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="text-gray-700 hover:text-primary-600 p-2"
                aria-label="Toggle menu"
              >
                <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="h-6 w-6" />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation Bar */}
      <div className="bg-gray-50 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Desktop Navigation */}
          <nav className="hidden md:flex justify-center space-x-8 py-4">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                  isActive(item.href)
                    ? 'text-primary-600 bg-primary-50 border border-primary-200'
                    : 'text-gray-700 hover:text-primary-600 hover:bg-primary-50'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <motion.div
              initial={{opacity: 0, height: 0}}
              animate={{opacity: 1, height: 'auto'}}
              exit={{opacity: 0, height: 0}}
              className="md:hidden"
            >
              <div className="px-2 pt-2 pb-3 space-y-1">
                {/* Mobile Partnership Logos */}
                <div className="flex items-center justify-center space-x-3 py-4 border-b border-gray-100">
                  <img
                    src="https://app1.sharemyimage.com/2025/05/19/burbank-insurance-services-in-california-logo.png"
                    alt="Burbank Insurance"
                    className="h-8 w-auto"
                  />
                  <div className="bg-primary-100 rounded-full p-1">
                    <SafeIcon icon={FiPlus} className="h-3 w-3 text-primary-600" />
                  </div>
                  <img
                    src="https://cdn1.sharemyimage.com/smi/2025/09/08/Next_Insurance_Logo.svg.png"
                    alt="Next Insurance"
                    className="h-6 w-auto"
                  />
                </div>
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    onClick={() => setIsMenuOpen(false)}
                    className={`block px-3 py-2 rounded-md text-base font-medium transition-colors ${
                      isActive(item.href)
                        ? 'text-primary-600 bg-primary-50'
                        : 'text-gray-700 hover:text-primary-600 hover:bg-primary-50'
                    }`}
                  >
                    {item.name}
                  </Link>
                ))}
              </div>
            </motion.div>
          )}
        </div>
      </div>

      {/* Tagline Banner - Below Navigation */}
      <div className="bg-gradient-to-r from-primary-600 to-primary-700 text-white py-2">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <p className="text-sm font-medium">
              <span className="text-white">100% Online</span> • No Agents Needed • <span className="text-primary-100">Instant Quotes</span>
            </p>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;